<template>
  <el-dialog :close-on-click-modal="false"
    custom-class="webpay export"
    :visible.sync="visibleInner"
    top="1vh"
  >
    <payment-form />
    <span slot="title">
      <h4>Настройка полей для экспорта платежей</h4>
    </span>
    <span slot="footer">
      <div class="aligner">
        <el-button round @click="visibleInner = false" type="primary"
          >Экспорт</el-button
        >
      </div>
    </span>
  </el-dialog>
</template>

<script>
import PaymentForm from './PaymentForm.vue'

export default {
  components: { 'payment-form': PaymentForm },
  name: 'payment-modal',
  props: ['visible'],
  computed: {
    visibleInner: {
      get () {
        return this.visible
      },
      set (val) {
        if (!val) {
          this.$emit('update:visible', false)
        }
      }
    }
  }
}
</script>

<style>
.el-dialog.webpay.export {
  max-width: 620px;
}
</style>
